import { gql } from 'src/__generated__';

const GET_MASTER_DEVICE_CALIBRATION = gql(`#graphql
query DeviceCalibration_MasterDeviceCalibration($deviceId: ID!) {
  device(input: { id: $deviceId }) {
    id
    sensors {
      id
      childDevice {
        id
        profile {
          id
          sensor
        }
        sensors {
          type {
            id
          }
        }
        dataConfiguration {
          deviceId
          calibration {
            level
            positionFromAngle {
              K
              P
              R
            }
            inverted
          }
        }
      }
    }
  }
}
`);

export default GET_MASTER_DEVICE_CALIBRATION;
